// extracted by mini-css-extract-plugin
export default {"modalbody":"Modal_modalbody__vJJT4","close-btn":"Modal_close-btn__6hQdY"};